import React, { createContext, useContext, useState } from "react";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("currentPage");
    return savedPage ? parseInt(savedPage, 10) : 1;
  });

  const setValidatedPage = (page) => {
    if (typeof page === "number" && page > 0) {
      localStorage.setItem("currentPage", page);
      setCurrentPage(page);
    } else {
      console.warn("Página inválida:", page);
    }
  };

  return (
    <PageContext.Provider value={{ currentPage, setCurrentPage: setValidatedPage }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePageContext deve ser usado dentro de um PageProvider");
  }
  return context;
};
